import svgUrl from "ni:svgr;oLQgQB7jMBAO4VtXQCQBeR1W9IchdcMHA5zC0BcDBAc";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const UiApiTableSIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M9.676 3.032a.5.5 0 0 1 .292.644l-3 8a.5.5 0 0 1-.936-.351l3-8a.5.5 0 0 1 .644-.293ZM4.8 3.1a.5.5 0 0 1 .1.7L2.125 7.5 4.9 11.2a.5.5 0 0 1-.8.6l-3-4a.5.5 0 0 1 0-.6l3-4a.5.5 0 0 1 .7-.1Zm6.3.7a.5.5 0 1 1 .8-.6l3 4a.5.5 0 0 1 0 .6l-3 4a.5.5 0 0 1-.8-.6l2.775-3.7L11.1 3.8Z" clipRule="evenodd" /></svg>;
const Memo = memo(UiApiTableSIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "ui-node-icon(UiApiTableSIcon)";
}